import React, { useState, useEffect, useCallback } from 'react';
import { usePollingApi, fmtKST, apiFetch } from '../hooks/useApi';

const SENTIMENT_BADGE = {
  positive: { label: '긍정', cls: 'bg-green-900/60 text-green-300' },
  negative: { label: '부정', cls: 'bg-red-900/60 text-red-300' },
  neutral:  { label: '중립', cls: 'bg-gray-700 text-gray-400' },
};

export default function NewsSection() {
  const { data, loading, refetch } = usePollingApi('/api/news/?limit=20', 300000); // 5분
  const [fetching, setFetching] = useState(false);

  // 최초 마운트 시 뉴스 수집 트리거
  useEffect(() => {
    apiFetch('/api/news/fetch', { method: 'POST' })
      .then(() => refetch())
      .catch(() => {});
  }, []); // eslint-disable-next-line

  const handleFetch = useCallback(async () => {
    setFetching(true);
    try {
      await apiFetch('/api/news/fetch', { method: 'POST' });
      refetch();
    } catch {}
    setFetching(false);
  }, [refetch]);

  return (
    <div className="bg-gray-800 rounded-lg border border-gray-700">
      <div className="p-3 border-b border-gray-700 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-gray-400">뉴스 & 공시</h3>
        <button onClick={handleFetch} disabled={fetching}
          className="text-xs bg-gray-700 hover:bg-gray-600 disabled:opacity-50 px-2 py-1 rounded transition">
          {fetching ? '수집 중...' : '뉴스 수집'}
        </button>
      </div>
      {loading && !data ? (
        <div className="p-4 text-sm text-gray-500">로딩 중...</div>
      ) : !data || data.length === 0 ? (
        <div className="p-4 text-sm text-gray-500">뉴스 데이터 없음</div>
      ) : (
        <div className="divide-y divide-gray-700/50 max-h-80 overflow-y-auto">
          {data.map((n, i) => (
            <div key={i} className="p-3 hover:bg-gray-750 transition">
              <div className="flex items-center gap-2 mb-1">
                {n.ticker && (
                  <span className="text-xs bg-blue-900/50 text-blue-300 px-1.5 py-0.5 rounded flex-shrink-0">
                    {n.ticker}
                  </span>
                )}
                {n.sentiment && SENTIMENT_BADGE[n.sentiment] && (
                  <span className={`text-xs px-1.5 py-0.5 rounded flex-shrink-0 ${SENTIMENT_BADGE[n.sentiment].cls}`}
                    title={n.sentiment_summary || ''}>
                    {SENTIMENT_BADGE[n.sentiment].label}
                  </span>
                )}
                <span className="text-xs text-gray-500 flex-shrink-0">{fmtKST(n.fetched_at)}</span>
              </div>
              {n.url ? (
                <a href={n.url} target="_blank" rel="noopener noreferrer"
                  className="text-sm text-gray-200 hover:text-blue-400 line-clamp-2 block transition">{n.title}</a>
              ) : (
                <div className="text-sm text-gray-200 line-clamp-2">{n.title}</div>
              )}
              {n.description && (
                <div className="text-xs text-gray-500 mt-1 line-clamp-1">{n.description}</div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
